import { makeRequest } from 'utils/requestLogger';

export default (courseID, feedbackID, text) =>
  makeRequest('put', `/api/courses/${courseID}/edit-feedback/${feedbackID}`, {
    text,
  });



// WEBPACK FOOTER //
// ./src/app/services/courses/updateFeedback.js